import { render, staticRenderFns } from "./BioModal.vue?vue&type=template&id=459786e0&scoped=true"
import script from "./BioModal.vue?vue&type=script&lang=js"
export * from "./BioModal.vue?vue&type=script&lang=js"
import style1 from "./BioModal.vue?vue&type=style&index=1&id=459786e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459786e0",
  null
  
)

export default component.exports